import React from 'react';
import { Section } from './ui/Section';
export function SocialProof() {
  const stats = [{
    icon: '👯',
    value: '+5.000',
    label: 'Instructoras en España usando el sistema'
  }, {
    icon: '🏫',
    value: '+800',
    label: 'Academias que lo utilizan actualmente'
  }, {
    icon: '📄',
    value: '+120K',
    label: 'Recursos descargados este año'
  }, {
    icon: '⏰',
    value: '94%',
    label: 'Ahorran +5 horas semanales de planificación'
  }];
  return <Section data-id="element-269">
      <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-270">
        ← Scroll to see full table →
      </div>

      <div className="overflow-x-auto" data-id="element-271">
        <table className="w-full min-w-[600px] border-collapse bg-white rounded-2xl overflow-hidden shadow-card border border-brand-border" data-id="element-272">
          <thead data-id="element-273">
            <tr className="bg-brand-bgAlt border-b border-brand-border" data-id="element-274">
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-275">
                Métrica
              </th>
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-276">
                Número
              </th>
              <th className="text-left p-3 text-brand-subtitle font-heading font-bold tracking-wide uppercase text-sm" data-id="element-277">
                Descripción
              </th>
            </tr>
          </thead>
          <tbody data-id="element-278">
            {stats.map((stat, i) => <tr key={i} className="hover:bg-brand-bgAlt transition-colors border-b border-brand-border last:border-0" data-id="element-279">
                <td className="p-3 text-brand-text font-body flex items-center gap-2" data-id="element-280">
                  <span className="text-2xl" data-id="element-281">{stat.icon}</span>
                  <span className="font-semibold" data-id="element-282">
                    Instructoras en la comunidad
                  </span>
                </td>
                <td className="p-3 text-brand-title font-heading font-bold text-xl" data-id="element-283">
                  {stat.value}
                </td>
                <td className="p-3 text-brand-text font-body" data-id="element-284">{stat.label}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Section>;
}